import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

const sendSSTKClickEvent = (event) => {
  const targetElement = event.target.closest('.sstk-results a');
  if (!targetElement) return;

  triggerCustomEvent(events.sstk.results_click, {});
};

export default sendSSTKClickEvent;
